import copyToClipboard from 'quasar/src/utils/copy-to-clipboard.js';
import date from 'quasar/src/utils/date.js';
import scroll from 'quasar/src/utils/scroll.js';
const { getScrollTarget, setScrollPosition } = scroll

export default {
    install(Vue) {
        Vue.mixin({
            methods: {
                getLicenseStatus(expiry) {
                    let diff = date.getDateDiff(expiry, Date.now(), 'days')
                    if (diff > 0) return true
                    else return false
                },
                wrapCsvValue(val, formatFn) {
                    let formatted = formatFn !== void 0
                        ? formatFn(val)
                        : val

                    formatted = formatted === void 0 || formatted === null
                        ? ''
                        : String(formatted)

                    formatted = formatted.split('"').join('""')
                    /**
                     * Excel accepts \n and \r in strings, but some other CSV parsers do not
                     * Uncomment the next two lines to escape new lines
                     */
                    // .split('\n').join('\\n')
                    // .split('\r').join('\\r')

                    return `"${formatted}"`
                },
                isExpired(date) {
                    if (!date) return false
                    let d1 = new Date()
                    let d2 = new Date(date)
                    if (d1 > d2)
                        return true
                    return false
                },
                getOrderStatusColor(status) {
                    if (!status) return ''

                    status = status.toString().trim()
                    if (status == '0' || status.includes('Created'))
                        return 'grey'

                    if (status == '1' || status.includes('Progress') || status.includes('Pending'))
                        return 'info'

                    if (status == '2' || status.includes('Cancelled'))
                        return 'grey'

                    if (status == '3' || status.includes('Complete'))
                        return 'positive'

                    if (status == '4' || status.includes('Failed'))
                        return 'negative'

                    if (status == '5' || status.includes('Declined'))
                        return 'warning'

                    if (status == '6' || status.includes('Processing') || status.includes('Started'))
                        return 'grey'

                    return ''
                },
                getOrderStatus(status) {
                    switch (status) {
                        case 0:
                            return 'Created'
                        case 1:
                            return 'In Progress'
                        case 2:
                            return 'Cancelled'
                        case 3:
                            return 'Complete'
                        case 4:
                            return 'Failed'
                        case 5:
                            return 'Declined'
                        case 6:
                            return 'Processing'
                        default:
                            return status
                    }
                },
                getAccountStatus(status) {
                    switch (status) {
                        case 0:
                            return 'Inactive'
                        case 1:
                            return 'Active'
                        case 2:
                            return 'Suspended'
                        default:
                            return 'Status Unset'
                    }
                },
                getAccountStatusColor(status) {
                    if (!status) return ''

                    status = status.toString().trim()
                    if (status == '0' || status.includes('Inactive'))
                        return 'info'
                    if (status == '1' || status.includes('Active'))
                        return 'positive'
                    if (status == '2' || status.includes('Suspended'))
                        return 'negative'
                    return ''
                },

                invalidHttpStatusCode(statusCode) {
                    if (!statusCode) return statusCode
                    if (statusCode >= 400) return true
                    return false
                },
                copyClipboard(text) {
                    copyToClipboard(text)
                        .then(() => {
                            // success!
                            this.$q.notify({
                                type: 'positive',
                                message: `${text} copied to clipboard`
                            })
                        })
                        .catch(() => {
                            // fail
                            this.$q.notify({
                                type: 'negative',
                                message: `Copy to clipboard failed`
                            })
                        })
                },
                scrollToElement(el) {
                    const target = getScrollTarget(el)
                    const offset = el.offsetTop
                    const duration = 500
                    setScrollPosition(target, offset, duration)
                },
                groupBy(list, keyGetter) {
                    if (!list) return null
                    const map = new Map()
                    list.forEach((item) => {
                        const key = keyGetter(item)
                        const collection = map.get(key)
                        if (!collection) {
                            map.set(key, [item])
                        } else {
                            collection.push(item)
                        }
                    })
                    return map
                },
                downloadFile(filepath) {
                    fetch(filepath,
                        { method: "HEAD" }
                    ).then((res) => {
                        if (res.ok) {
                            // file is present at URL
                            const filename = filepath.replace(/^.*[\\\/]/, '')
                            let link = document.createElement('a')
                            link.href = filepath
                            link.style.display = 'none'
                            link.download = filename
                            document.body.appendChild(link)
                            link.click()

                            setTimeout(function () {
                                // For Firefox it is necessary to delay revoking the ObjectURL
                                document.body.removeChild(link)
                            }, 100)
                        } else {
                            // file is not present at URL
                            this.$q.notify({
                                type: 'negative',
                                message: 'File does not exist'
                            })
                        }
                    })
                },
            }
        })
    }
}
